const validate = (values) => {
  const errors = {};

  if (!values.tag || values.tag.trim() === '') {
    errors.tag = 'Please enter tag name';
  }
  // if (!values.Description) {
  //   errors.Description = 'Please enter description';
  // }
  // console.log(typeof values.ColorCode);
  // if (!values.ColorCode || values.ColorCode.trim() === '') {
  //   errors.ColorCode = 'Please select color';
  // }
  // if (typeof values.ColorCode === 'undefined') {
  //   errors.ColorCode = 'undefined color';
  // }
  if (!values.roleTypeID) {
    errors.roleTypeID = 'Please choose a role to link';
  } else if (!Number.isInteger(values.roleTypeID)) {
    errors.roleTypeID = 'Please select an option';
  }

  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/validate.js